import { User } from '@/models'

export default {
  created () {
    if (!this.$store.state.myKintell.userActivitySession) {
      const userActivitySession = Math.random().toString(36).substring(2)
      this.$store.commit('myKintell/SET_USER_ACTIVITY_SESSION', userActivitySession)
    }
  },
  methods: {
    sendUserActivity (data) {
      data.session = this.$store.state.myKintell.userActivitySession
      return (new User()).action('activity', data)
    }
  }
}
